<template>
  <div class="m-agreement">
    <div class="navbar">
      <button class="back" @click="goBack">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
             stroke-linejoin="round">
          <path d="M15 19l-7-7 7-7"/>
        </svg>
      </button>
      <h1>{{ title }}</h1></div>

    <div class="scroll ag-body" v-if="loading">
      <div class="m-loading"><span class="spin"></span>
        <p>加载中…</p></div>
    </div>
    <div class="scroll ag-body" v-else-if="error">{{ error }}</div>
    <div class="scroll ag-body" v-else v-html="content"></div>
  </div>
</template>

<script>
import mobileRem from '@/commonJs/mobileRem';

export default {
  name: 'MAgreement',
  mixins: [mobileRem],
  data() {
    return {
      title: '',
      content: '',
      loading: false,
      error: ''
    };
  },
  mounted() {
    this.loadAgreement();
  },
  methods: {
    loadAgreement() {
      const type = this.$route.query.type || 'user';
      const fileName = type === 'privacy' ? 'privacy.html' : 'agreement.html';

      this.loading = true;
      this.error = '';

      fetch('/static/' + fileName)
        .then(response => {
          if (!response.ok) {
            throw new Error('加载失败');
          }
          return response.text();
        })
        .then(html => {
          this.title = type === 'privacy' ? '隐私政策' : '用户协议';
          this.content = html;
        })
        .catch(err => {
          console.error('加载协议文件失败：', err);
          this.error = '加载失败，请稍后重试';
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent
}

.m-agreement {
  --t1: #14181f;
  --t2: #5b6472;
  --t3: #9aa4b2;
  --line: #eef0f4;
  --bg: #f4f6f8;
  --card: #fff;
  font-size: 14px;
  line-height: normal;
  -webkit-text-size-adjust: 100%;
  height: 100vh;
  background: var(--bg);
  display: flex;
  flex-direction: column;
  overflow: hidden
}

.navbar {
  height: 46px;
  flex: none;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-bottom: .5px solid rgba(0, 0, 0, .15);
  z-index: 10
}

.navbar h1 {
  font-size: 17px;
  font-weight: 600;
  color: var(--t1)
}

.navbar .back {
  position: absolute;
  left: 4px;
  top: 0;
  height: 46px;
  width: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--t1);
  cursor: pointer;
  background: none;
  border: none
}

.navbar .back svg {
  width: 19px;
  height: 19px
}

.scroll {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch
}

.ag-body {
  padding: 16px 14px 30px;
  line-height: 1.8;
  font-size: 14px;
  color: #333;
  word-wrap: break-word;
  word-break: break-word
}

/* 列表加载态 */
.m-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 90px 0;
  gap: 12px
}

.spin {
  width: 32px;
  height: 32px;
  border: 3px solid rgba(0, 0, 0, .08);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin .8s linear infinite
}

.m-loading p {
  font-size: 13px;
  color: var(--t3);
  margin: 0
}

@keyframes spin {
  to {
    transform: rotate(360deg)
  }
}

/* 覆盖 Word 生成的 HTML 样式，使其移动端友好 */
.ag-body ::v-deep * {
  max-width: 100% !important;
  box-sizing: border-box !important
}

.ag-body ::v-deep body,
.ag-body ::v-deep html {
  font-family: inherit !important;
  font-size: inherit !important;
  line-height: inherit !important;
  margin: 0 !important;
  padding: 0 !important
}

.ag-body ::v-deep p {
  margin: 0 0 12px !important;
  text-indent: 0 !important;
  line-height: 1.8 !important;
  font-size: 14px !important;
  text-align: justify
}

.ag-body ::v-deep h1,
.ag-body ::v-deep h2,
.ag-body ::v-deep h3,
.ag-body ::v-deep h4,
.ag-body ::v-deep h5,
.ag-body ::v-deep h6 {
  margin: 16px 0 10px !important;
  font-weight: 600 !important;
  line-height: 1.5 !important;
  color: #1f2733 !important
}

.ag-body ::v-deep h1 {
  font-size: 18px !important
}

.ag-body ::v-deep h2 {
  font-size: 17px !important
}

.ag-body ::v-deep h3 {
  font-size: 16px !important
}

.ag-body ::v-deep h4 {
  font-size: 15px !important
}

.ag-body ::v-deep table {
  width: 100% !important;
  max-width: 100% !important;
  margin: 12px 0 !important;
  border-collapse: collapse !important;
  font-size: 13px !important
}

.ag-body ::v-deep td,
.ag-body ::v-deep th {
  padding: 8px !important;
  border: 1px solid #eef0f4 !important;
  word-wrap: break-word !important;
  word-break: break-word !important
}

.ag-body ::v-deep img {
  max-width: 100% !important;
  height: auto !important;
  display: block !important;
  margin: 8px 0 !important
}

.ag-body ::v-deep span,
.ag-body ::v-deep div {
  font-size: inherit !important;
  line-height: inherit !important
}

.ag-body ::v-deep .MsoNormal {
  margin: 0 0 12px !important;
  line-height: 1.8 !important
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/MAgreement.vue